const THEME_LIST = [
    { key: '1', value: '蓝色' },
    { key: '2', value: '红色' },
    { key: '3', value: '绿色' }
];

export default {
    THEME_LIST
};

export const captchaConfig = {
    host: 'https://support.grtcloud.net',
    captchaId: 'd0752a0a-11ae-11eb-9273-e41f13671c48'
};

export const competition_constants = {
    business_id: '1770786866887421954',
    template_id: '201'
};

export const fieldTypeMap = {
    // 1-文本 2-下拉 3-数值 4-级联 5-日期 6 -上传 7-前端自定义类型 org_id  8-附件
    TEXT: 1,
    SELECTED: 2,
    NUMBER: 3,
    CASCADE: 4,
    DATE: 5,
    UPLOAD: 6,
    SELECTEDTREE: 7,
    FILE: 8
};
